<template>
  <div id="main-content">
    <a-form layout="inline" style="background: #ffffff;padding: 10px;margin-bottom: 10px;">
      <a-form-item style="margin: 0;float: right;">
        <a-button icon="plus" type="primary" primary @click="clickAdd()">添加</a-button>
      </a-form-item>
      <a-form-item style="float: right;">
        <a-button icon="rollback" type="danger" primary @click="goback()">返回</a-button>
      </a-form-item>
      <a-form-item>
        <a-input v-model="filter.name" allowClear @pressEnter="init_data" placeholder="名称">
          <a-icon slot="prefix" type="dropbox" style="color:rgba(0,0,0,.25)" />
        </a-input>
      </a-form-item>
      <a-form-item>
        <a-input v-model="filter.key" allowClear @pressEnter="init_data" placeholder="键名">
          <a-icon slot="prefix" type="dropbox" style="color:rgba(0,0,0,.25)" />
        </a-input>
      </a-form-item>

      <a-form-item style="float: right;margin: 0">
        <!--<a-button icon="sync" html-type="submit" ></a-button>-->
      </a-form-item>
    </a-form>
    <a-table :columns="getTableColumns" :data-source="tableData" style="background: #ffffff;" :loading="tableLoad"
      :rowKey="item => item.id" bordered :pagination="false">

      <template slot="handle" slot-scope="text,record">
        <a-button size="small" @click="clickEdit(record)">编辑</a-button>
        <a-button type="danger" size="small" @click="clickDel(record)">删除</a-button>
      </template>
      <template slot="footer">
        <a-pagination v-model="page" style="text-align: right" show-size-changer :total="count" :page-size="page_size"
          @change="changePage" @showSizeChange="changePage" />
      </template>
    </a-table>

    <ConfigEditDialog :show-dialog="editDialogShow" :dataInfo="dataInfo" :title="editTitle" :typeList="typeList"
      @close-dialog="closeDialog()"></ConfigEditDialog>
  </div>
</template>

<script>
import { GetConfigPage, ConfigDelete, GetConfigTypeAll } from "@/api/v1/config_api";
import ConfigEditDialog from "@/components/V1/ConfigEditDialog";

export default {
  name: "ConfigType",
  components: { ConfigEditDialog },
  data() {
    return {
      filter: {
        name: '',
        key: '',
        type_id: ''
      },
      tableData: [],
      count: 100,
      page: 1,
      page_size: 10,
      tableLoad: false,
      dataInfo: {},
      typeList: [],
      editDialogShow: false,
      editTitle: '',
    }
  },
  mounted() {
    this.filter.type_id = parseInt(this.$route.query.type_id)
    this.init_data()
  },
  computed: {
    getTableColumns() {
      let _table_columns = [
        { title: '名称', dataIndex: 'name', scopedSlots: { customRender: 'name' }, },
        { title: '键名', dataIndex: 'key', scopedSlots: { customRender: 'key' }, },
        { title: '键值', dataIndex: 'value', scopedSlots: { customRender: 'value' }, },
        { title: '备注', dataIndex: 'remarks', scopedSlots: { customRender: 'remarks' }, },
        { title: '操作', dataIndex: 'handle', scopedSlots: { customRender: 'handle' } },
      ]
      return _table_columns
    }
  },
  methods: {
    init_data() {
      if (this.tableLoad) return
      this.tableLoad = true
      GetConfigPage({
        name: this.filter.name,
        type_id: this.filter.type_id,
        key: this.filter.key,
        page: this.page,
        page_size: this.page_size
      }).then(resp => {
        this.tableLoad = false
        if (resp.code === 200) {
          this.tableData = resp.data.list
          this.count = parseInt(resp.data.count)
          this.page = parseInt(resp.data.page)
          this.page_size = parseInt(resp.data.page_size)
        }
      })
    },

    changePage(page, page_size) {
      this.page = page
      this.page_size = page_size
      this.init_data()
    },
    closeDialog() {
      this.dataInfo = {}
      this.editDialogShow = false
      this.init_data()
    },
    clickEdit(record) {
      this.editTitle = '编辑'
      this.dataInfo = record
      this.editDialogShow = true
    },
    clickDel(record) {
      let that = this
      this.$confirm({
        title: '是否确定删除数据?',
        content: '删除后数据无法正常使用',
        onOk() {
          ConfigDelete({
            id: record.id,
          }).then(resp => {
            if (resp.code === 200) {
              that.$message.success('删除成功')
              that.init_data()
            } else {
              that.$message.error(resp.msg)
              that.init_data()
            }
          })
        },
        onCancel() { },
      });

    },
    clickAdd() {
      let that = this
      GetConfigTypeAll({}).then(resp => {
        if (resp.code === 200) {
          this.typeList = resp.data
          that.editTitle = '添加'
          that.dataInfo = {
            'type_id': that.filter.type_id
          }
          that.editDialogShow = true
        } else {
          that.$message.error(resp.msg)
        }
      })
    },
    goback() {
      this.$router.push({path:'/config_type'})
      // this.$router.go(-1)
    }

  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/System/Config/Config.vue